import { Component } from '@angular/core';
import { ColumnTypesEnum } from '@r1-development/rps-shared-ui';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

/**
 * LinkCellComponent serves for a link, routerLink, and returns click event
 * For routerLink, set isRouterLink = true, routerLink="<router-link>" queryParams=<{key: value}>
 * For only link, set isRouterLink = false, isReturnClickEvent = true
 */
@Component({
    selector: 'app-link-cell',
    templateUrl: './link-cell.component.html',
    styleUrls: ['./link-cell.component.scss'],
    standalone: false
})
export class LinkCellComponent implements ICellRendererAngularComp {
  value: any;
  rowData: any;
  notAvailable = ColumnTypesEnum.NotAvailable;
  isReturnClickEvent = false;
  routerLink = '';
  queryParams = {};
  isRouterLink = false;
  styleClass = '';
  private params: any;

  agInit(params: ICellRendererParams<any, any>): void {
    const dataParams = params.colDef.cellRendererParams;
    this.value = params.value;
    this.rowData = params.data;
    this.params = params;
    this.isReturnClickEvent = dataParams?.isReturnClickEvent;
    this.isRouterLink = dataParams?.isRouterLink;
    this.styleClass = dataParams?.styleClass;
    if (this.isRouterLink) {
      this.routerLink = dataParams?.routerLink;
      this.queryParams = dataParams?.queryParams(params);
    }
  }

  clickHandler(data: any) {
    if (this.isReturnClickEvent) {
      this.params.clicked(this.params);
    } else {
      this.params.context.showDialog(data, true, true);
    }
  }

  refresh(): boolean {
    return false;
  }
}
